import { render, staticRenderFns } from "./AboutTabs.vue?vue&type=template&id=106191ae"
import script from "./AboutTabs.vue?vue&type=script&lang=js"
export * from "./AboutTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports